import React, { useEffect, useState } from "react";
import { Input, InputNumber } from "antd";
import {
    getRowTableStartMode,
    rowTableStartsAtToLabel,
    rowTableLabelToStartsAt,
} from "../../../utils/RowTableDistributionUtil";

const LETTER_PATTERN = /[^a-zA-Z]/g;
const ROMAN_PATTERN = /[^ivxlcdmIVXLCDM]/g;

export const RowTableStartsAtInput = React.forwardRef(
    ({ distributionKey, value, onChange }, ref) => {
        const mode = getRowTableStartMode(distributionKey);

        const [text, setText] = useState(() =>
            rowTableStartsAtToLabel(distributionKey, value ?? 1)
        );

        // Keep the displayed label in sync when the numeric value or the
        // distribution changes from the outside.
        useEffect(() => {
            if (mode === "letter" || mode === "roman") {
                setText(rowTableStartsAtToLabel(distributionKey, value ?? 1));
            }
        }, [value, distributionKey, mode]);

        if (mode === "none") return null;

        if (mode === "number") {
            return (
                <InputNumber
                    ref={ref}
                    min={1}
                    value={value}
                    onChange={onChange}
                />
            );
        }

        const handleChange = (event) => {
            const raw = event.target.value ?? "";
            const filtered =
                mode === "letter"
                    ? raw.replace(LETTER_PATTERN, "").toUpperCase()
                    : raw.replace(ROMAN_PATTERN, "").toUpperCase();

            // Allow the field to be empty while editing.
            setText(filtered);

            if (filtered === "") return;

            onChange && onChange(rowTableLabelToStartsAt(distributionKey, filtered));
        };

        const handleBlur = () => {
            if (text === "") {
                setText(rowTableStartsAtToLabel(distributionKey, 1));
                onChange && onChange(1);
            }
        };

        return (
            <Input
                ref={ref}
                value={text}
                onChange={handleChange}
                onBlur={handleBlur}
            />
        );
    }
);
